import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { UiIcon } from 'ui-components';
import { changeProfileMenuStep } from 'store';

const MobileSizeSupportThanks = ({ close }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <>
      <div className='modal-header step-header'>
        <div className='header-info'>
          <UiIcon
            className='mr-0'
            icon='ri-arrow-right-s-line'
            size={20}
            color='#454545'
            onClick={() => dispatch(changeProfileMenuStep('step_1'))}
          />
          <span className='label'>{t('support:pageTitle')}</span>
        </div>
        <UiIcon
          className='header-close'
          icon='ri-close-circle-fill'
          size={20}
          color='#9CAEBB'
          onClick={close}
        />
      </div>

      <div className='modal-body'>
        <div className='body-support mt-32 mb-16'>
          <p className='m-0'>{t('support:yourFeedbackRegistered')}</p>
          <div className=''>
            <span className='m-0'>
              {t('support:thankYouForHelpingUsToImprove')}
            </span>
            <UiIcon
              className='inline-block mr-10'
              icon='ri-heart-fill'
              size={20}
              color='#ff0000'
              style={{
                position: 'relative',
                top: '5px',
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

MobileSizeSupportThanks.propTypes = {
  close: PropTypes.func,
};

export default MobileSizeSupportThanks;
